<div class="content-container" (click)="dismissModal()">
    <div (click)="$event.stopPropagation()" [style]="style" class="content">
        <ng-content></ng-content>
    </div>
</div>